import { authRoles } from 'app/auth';
import EgyszeruKerdesTable from 'app/admin/egyszerukerdes/table/EgyszeruKerdesTable';
import EgyszeruKerdesEditForm from 'app/admin/egyszerukerdes/editform/EgyszeruKerdesEditForm';

export default [
	{
		path: '/egyszerukerdes/edit/:id',
		component: EgyszeruKerdesEditForm,
		auth: authRoles.admin
	},
	{
		path: '/egyszerukerdes/:sessionNameParam?',
		component: EgyszeruKerdesTable,
		auth: authRoles.admin
	}
];
